// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star-svg_size10_7ebab809 {
  width: 0.834rem;
  height: 0.79rem;
}
.star-svg_size10_7ebab809 .star-svg__item_empty_7ebab809 {
  stroke-width: 4.267rem;
}
.star-svg_size10_7ebab809 .star-svg__item_filled_7ebab809 {
  stroke-width: 4.267rem;
}
.star-svg_size18_7ebab809 {
  width: 1.5rem;
  height: 1.421rem;
}
.star-svg_size18_7ebab809 .star-svg__item_empty_7ebab809 {
  stroke-width: 2.371rem;
}
.star-svg_size18_7ebab809 .star-svg__item_filled_7ebab809 {
  stroke-width: 2.371rem;
}
.star-svg_size24_7ebab809 {
  width: 2rem;
  height: 1.895rem;
}
.star-svg_size24_7ebab809 .star-svg__item_empty_7ebab809 {
  stroke-width: 1.778rem;
}
.star-svg_size24_7ebab809 .star-svg__item_filled_7ebab809 {
  stroke-width: 1.778rem;
}
.star-svg_size36_7ebab809 {
  width: 3rem;
  height: 2.842rem;
}
.star-svg_size36_7ebab809 .star-svg__item_empty_7ebab809 {
  stroke-width: 1.186rem;
}
.star-svg_size36_7ebab809 .star-svg__item_filled_7ebab809 {
  stroke-width: 1.186rem;
}
.star-svg_blue_7ebab809 .star-svg__item_empty_7ebab809 {
  fill: #fbfcfd;
  stroke: #84919b;
}
.star-svg_blue_7ebab809 .star-svg__item_filled_7ebab809 {
  fill: #6185a6;
  stroke: #6185a6;
}
.star-svg_blue_7ebab809 .star-svg__item_half-filled_7ebab809 {
  fill: #6185a6;
}
.star-svg_yellow_7ebab809 .star-svg__item_empty_7ebab809 {
  fill: #fff;
  stroke: #f5c914;
}
.star-svg_yellow_7ebab809 .star-svg__item_filled_7ebab809 {
  fill: #f5c914;
  stroke: #f5c914;
}
.star-svg_yellow_7ebab809 .star-svg__item_half-filled_7ebab809 {
  fill: #f5c914;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"star-svg_size10": `star-svg_size10_7ebab809`,
	"star-svg__item_empty": `star-svg__item_empty_7ebab809`,
	"star-svg__item_filled": `star-svg__item_filled_7ebab809`,
	"star-svg_size18": `star-svg_size18_7ebab809`,
	"star-svg_size24": `star-svg_size24_7ebab809`,
	"star-svg_size36": `star-svg_size36_7ebab809`,
	"star-svg_blue": `star-svg_blue_7ebab809`,
	"star-svg__item_half-filled": `star-svg__item_half-filled_7ebab809`,
	"star-svg_yellow": `star-svg_yellow_7ebab809`
};
export default ___CSS_LOADER_EXPORT___;
